const reducer = async (action, data, state, prevState) => {
  return state;  
};

export default reducer;
